import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core";
import { useGetConsultantServicePreferencesForBookingQuery } from "@bonliva-crm/graphql";
import { locale } from "@bonliva-crm/locale";
import moment from "moment";

export function ConsultantServicePreferencesAlert({ bookingId }: { bookingId: string }) {
  const classes = useStyles();

  const query = useGetConsultantServicePreferencesForBookingQuery({
    variables: {
      bookingId
    },
    fetchPolicy: "network-only"
  });

  const data = query.data?.consultantServicePreferencesForBooking;

  if (!data?.length) {
    return null;
  }

  return (
    <Alert key={"consultantServicePref"} severity="info" className={classes.alert}>
      <span className={classes.content}>
        <span className={classes.label}>Servicepreferenser: </span>
        {data.map((item, idx) => {
          const createdBy = `${locale.createdBy} ${item.createdByName} ${formatDate(
            item.createdOn
          )}`;

          return (
            <div key={idx} className={classes.item}>
              <p>{item.description}</p>
              <p className={classes.createdBy}>{createdBy}</p>
            </div>
          );
        })}
      </span>
    </Alert>
  );
}

function formatDate(date: Date) {
  return moment(date).format("YYYY-MM-DD");
}

export const useStyles = makeStyles(() => ({
  alert: {
    borderRadius: 0,
    color: "#0d3c61",
    backgroundColor: "#e8f4fd",

    "& svg": {
      color: "#0d3c61"
    }
  },
  content: { color: "#521e1e", whiteSpace: "pre-line" },
  label: { fontWeight: "bold" },
  item: {
    "& p": {
      margin: "5px 0"
    },
    "& + &": {
      borderTop: "1px solid #000"
    }
  },
  createdBy: { fontSize: "12px", marginTop: "5px" }
}));
